import { NeoModel, ModelBase, Attributes, Misc, Validation, Rules } from '@singularsystems/neo-core';

@NeoModel
export default class InstrumentSearchLookup extends ModelBase {
    public instrumentID: number = 0;

    @Rules.Required()
    @Rules.StringLength(200)
    public description:  string | null = null;

    @Rules.StringLength(20)
    @Rules.Required()
    public isin:  string | null = null;

    @Rules.Required()
    @Rules.StringLength(20)
    public ticker: string | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public maturityDate: Date | null = null;

    public isListedInstrumentInd: boolean = false;

    public instrumentType: string | null = null;

    public instrumentSubType: string | null = null;

    public instrumentSubTypeID: number | null = null;

    @Attributes.NoTracking()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public currentDate: Date = new Date();

    public isDeletedInd: boolean = false;

    public isDualListed: boolean = false;

    public isREIT: boolean = false;

    public isSelectedInd: boolean = false;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }
}